import axios, { AxiosResponse } from 'axios'
import {
  TSignUpRepsonse,
  TSignInResponse,
  // TMeRepsonse,
  TRefreshRepsonse,
  TUpdateUserFormValues
} from './types'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { resetAgencyStateAction, setAgencyAction, setProjectsAction } from '../agency/slice'
import { chooseProjectAction, resetProjectStateAction } from '../project/slice'
import {
  FormValues,
  TCheckTokenToResetFormValues,
  TForgotPassFormValues,
  TUpdatePasswordFormValues
} from '../../models/form'
import { appLogOutAction, setTokenAction, setUserRoleAction } from './slice'
import { RootState } from '..'
import { resetManagePostStateAction } from '../managePost/slice'

export const signUpThunk = createAsyncThunk(
  'auth/signUpThunk',
  async (data: FormValues, { rejectWithValue, dispatch }) => {
    try {
      const responseSignUp: AxiosResponse<TSignUpRepsonse> = await axios.post(`/auth/signup`, data)
      dispatch(setTokenAction(responseSignUp.data.data.token))
      await dispatch(getMeThunk())
      return responseSignUp.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const signInThunk = createAsyncThunk(
  'auth/signInThunk',
  async (data: FormValues, { rejectWithValue, dispatch }) => {
    try {
      const responseSignIn: AxiosResponse<TSignInResponse> = await axios.post(`/auth/signin`, data)
      dispatch(setTokenAction(responseSignIn.data.data.token))
      await dispatch(getMeThunk())
      return responseSignIn.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getMeThunk = createAsyncThunk(
  'auth/getMeThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(`/auth/me`)
      if (responseUserData.data.data.projects.length) {
        dispatch(chooseProjectAction(responseUserData.data.data.projects[0]))
      }
      dispatch(setAgencyAction(responseUserData.data.data.agency))
      dispatch(setProjectsAction(responseUserData.data.data.projects))
      return responseUserData.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const googleAuthThunk = createAsyncThunk(
  'auth/googleAuthThunk',
  async (queryString: string, { dispatch, rejectWithValue }) => {
    try {
      const responseGoogleSignIn: AxiosResponse<TSignInResponse> = await axios.get(
        `/auth/google/callback${queryString}`
      )
      dispatch(setTokenAction(responseGoogleSignIn.data.data.token))
      await dispatch(getMeThunk())
      return responseGoogleSignIn.data
    } catch (err) {
      return rejectWithValue({
        ...(err as any).response.data,
        status: (err as any).response.status
      })
    }
  }
)

export const appleAuthThunk = createAsyncThunk(
  'auth/appleAuthThunk',
  async (queryString: string, { dispatch, rejectWithValue }) => {
    try {
      const responseAppleSignIn: AxiosResponse<TSignInResponse> = await axios.get(
        `/auth/apple/callback${queryString}`
      )
      dispatch(setTokenAction(responseAppleSignIn.data.data.token))
      await dispatch(getMeThunk())
      return responseAppleSignIn.data
    } catch (err) {
      return rejectWithValue({
        ...(err as any).response.data,
        status: (err as any).response.status
      })
    }
  }
)

export const logOutThunk = createAsyncThunk(
  'auth/logOutThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TSignInResponse> = await axios.post(`/auth/logout`)
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    } finally {
      dispatch(resetManagePostStateAction())
      dispatch(resetAgencyStateAction())
      dispatch(appLogOutAction())
      dispatch(resetProjectStateAction())
    }
  }
)

export const refreshTokenThunk = createAsyncThunk(
  'auth/refreshTokenThunk',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const responseRefreshToken: AxiosResponse<TRefreshRepsonse> = await axios.post(
        `/auth/refresh`
      )
      dispatch(setTokenAction(responseRefreshToken.data.data))
      return responseRefreshToken.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const forgotPasswordThunk = createAsyncThunk(
  'auth/forgotPasswordThunk',
  async (data: TForgotPassFormValues, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/password/forgot`, data)
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const checkTokenToUpdatePasswordThunk = createAsyncThunk(
  'auth/checkTokenToUpdatePasswordThunk',
  async (data: TCheckTokenToResetFormValues, { rejectWithValue }) => {
    try {
      await axios.post(`/password/checktoken`, data)
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const updatePasswordThunk = createAsyncThunk(
  'auth/updatePasswordThunk',
  async (data: TUpdatePasswordFormValues, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/password/new`, data)
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const updateUserThunk = createAsyncThunk(
  'auth/updateUserThunk',
  async (data: TUpdateUserFormValues, { rejectWithValue, getState }) => {
    const {
      auth: { user }
    } = getState() as RootState
    try {
      data.append('_method', 'PUT')
      const response: AxiosResponse<any> = await axios.post(`/users/${user?.id}`, data)
      return response.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)
